import script from "./MWinningDistribution.vue?vue&type=script&setup=true&lang=ts"
export * from "./MWinningDistribution.vue?vue&type=script&setup=true&lang=ts"

import "./MWinningDistribution.vue?vue&type=style&index=0&id=c1664952&lang=less"

const __exports__ = script;

export default __exports__